export const environment = {
  production: true,
  maintenance: false,
  mfaRequiredForAllUsers: true,
  localApiServer: false,
  idleTimeoutSeconds: 1200,
  debugUserIdle: false,
  debugUserTiming: false,
  debugRouter: false,
  awsRegion: 'us-west-2',
  sentryDsn: 'https://ed2619de3ed247f989f2054a43ee141c@sentry.io/1449789',
  captureApi: {
    url: 'https://t40b-r-prod.par8o.com/api/v1',
  },
  helpscoutApi: {
    token: '2ab8e508-c60b-4dc4-b370-e903091ced66',
  },
  pendo: {
    enabled: true,
    environment: 'Production'
  },
  featureData: {
    consultNotePages: true,
    usePdfKitViewer: true,
  },
  psPdfKit: {
    // cspell:disable-next
    licenseKey: 'W9FKJdoSvHlUtD6I4Xfqhi3mtAujPILy7JiFDjyidaKE5DKdctiGPKeRNMFgEjrOfarRWmszrHNGOvjdP8vWwRYWX_9k0DJIBpEyifTYP4LkGkl8kGLhpaOkOdUbKF4vkKNT-apEokboKdYz216XU-kRnw0dGOIe5DxmY17rEZc8xKZMDhOdN99D-exZGKSrwjXj5uKjYOUtWAYwhGzik-6Z7yalIOm1--OxGVydaFbdiptJ-QiKhuFlwsQvdU_G90YlzT3Y-F6Ob4ECUoeaPJfikFtdLI80tDSVe_uHrEJFdS8zG0Zn2dQwFxEbD1Ectqe3_M5xMLSg_yWZLMgnxNp8ELdrKbN97CCHIzHMz8E4WFk-L9UFAQ6easUFWyiBrmgzaZ-fwbGo1qfk1JLYXCV9U0AxD2NGtHSo0d0Nj2RX3VQl2u4w95D39IBv58otkvv4s8LNSgXwJ4XS5H9i97hffTVC3-rPjXND6x5TcqFgcIj_NBOv6QgJqeeEUtATI6W0fh5JJIdJC_2Do93ysD6gJfypPp8M4IvHOsN1XYtFxOC0qUq6V6z95by7G-KwgyO4HCQlA6JXdesr8NHulkH1b1eDrp-0CLr96SI1LPA='
  },
};
